import { GroupCondition } from '@/api/enums';
import { equal, group, handleAxiosError } from '@/api/helpers';
import { client } from '@/client';
import { CourseStatusAttemptEnum, MaterialType } from '@/client/courses';
import { useToast } from '@/hooks/useToast';
import { LearnerDashboardPage } from '@/pages/dashboards/learner/courses/LearnerDashboardPage';
import { AxiosError } from 'axios';
import React, { useEffect, useState } from 'react';

export const LearnerDashboardActivePage: React.FC = () => {
  const toast = useToast();

  const [atLeastOneCompleted, setAtLeastOneCompleted] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const getOneCompletedScormCourse = async () => {
      try {
        setIsLoading(true);

        const response = await client.learnerCourses.getLearnerCourses({
          take: 1,
          skip: 0,
          type: CourseStatusAttemptEnum.COMPLETED,
          filters: [
            group(GroupCondition.OR, [
              equal('type', MaterialType.COURSE),
              equal('type', MaterialType.CUSTOM_MATERIAL),
            ]),
          ],
        });

        setAtLeastOneCompleted(response.count);
      } catch (e) {
        handleAxiosError(e as Error | AxiosError, toast);
      } finally {
        setIsLoading(false);
      }
    };
    getOneCompletedScormCourse();
  }, []);

  return (
    <LearnerDashboardPage
      type={CourseStatusAttemptEnum.IN_PROGRESS}
      atLeastOneCompleted={!!atLeastOneCompleted}
      isLoading={isLoading}
    />
  );
};
